import React, {useState,useEffect} from "react";
import {renderToString} from "react-dom/server";
import PrintTemplateCommunity from "../PrintTemplateCommunity";
import jwt from "jsonwebtoken";
import FunctionsData from "../../Functions/FunctionsData";
import {Button} from "@mui/material";
import moment from "moment";

export default function CommunityStep3({microchipOnly, outreach , postcode, aStep, setAStep, setFrmOrderID, frmFn, frmLn, frmStreet, frmStreetNumber, frmCity, frmEmail, frmPhone, frmDPID, suburb, formattedAddress, animals, currentVetArr, frmMarketingOptin, sponsorId, sponsorName, sponsorProgram, sponsorCost, sponsorMicrochipExtraCost, sponsorEmailText, sponsorLogo, orderDescription, jwtKey, frmCampaign,userAccount,targetPortal}) {

    const [btnDisabled, setBtnDisabled] = useState(false);
    const v = currentVetArr;
const [resolvedSponsor, setResolvedSponsor] = useState({         
  id: 0,
  name: '',
  program: '',
  cost: 0,
  microchipExtraCost: 0,
  emailText: '',
  logo: ''
});
const SPONSOR_STATUS = {
  OK: 'ok',            
  NO_VOUCHERS: 'no-vouchers',
  NOT_SERVED: 'not-served'
};
async function fetchSponsorByPostcode(pc,targetPortal) {
  const rsp = await fetch(
    FunctionsData.getApiUrl(`/api/campaign/resolvecampaign/${pc}/${targetPortal}`),
    { headers: { token: sessionStorage.tkn } }
  );

  if (rsp.status === 404) {
    return { status: SPONSOR_STATUS.NOT_SERVED }; 
  }
  if (!rsp.ok) {
    throw new Error(`Sponsor API failed (${rsp.status})`);
  }

  const payload = await rsp.json();     
  const sponsor = payload?.data;

  if (!sponsor || sponsor.vouchers_left === 0) {
    return { status: SPONSOR_STATUS.NO_VOUCHERS };
  }
  return { status: SPONSOR_STATUS.OK, sponsor };
}

useEffect(() => {
 if (!postcode || !targetPortal) return;

  setResolvedSponsor(prev => ({ ...prev, id: 0 }));

  // Sponsor programs apply to public vouchers only; community may opt a sponsor
  // in. Outreach/inspectors never resolve a sponsor, so skip the lookup entirely.
  if (String(targetPortal).toLowerCase() !== 'community') {
    setResolvedSponsor({ id: 0 });
    return;
  }

  fetchSponsorByPostcode(postcode,targetPortal)
    .then(result => {
      switch (result.status) {
        case SPONSOR_STATUS.OK: {
          const s = result.sponsor;
          setResolvedSponsor({
            id: s.id,
            name: s.name,
            program: s.program,
            cost: s.applicant_cost,
            microchipExtraCost: s.microchip_extra_cost,
            emailText: s.email_text_url,
            logo: s.logo
          });
          break;
        }
        case SPONSOR_STATUS.NO_VOUCHERS:
          setResolvedSponsor({ id: 0 });             
          break;

        case SPONSOR_STATUS.NOT_SERVED:
          console.warn('No sponsor serves this postcode');         
          break;
      }
    })
    .catch(err => {
      console.error('Sponsor lookup failed', err);      
    });
}, [postcode]);


    function getEmailHTML(orderIDInstance) {

        let arr = [];
        let expiry = moment().format('YYYY-MM-DD');
        for (let x in animals) {
            const r = animals[x];
            arr.push([r.name, r.voucher, r.expiry_date]);
            if (expiry < r.expiry_date) expiry = r.expiry_date;
        }

        const dec = {
            name: currentVetArr.business_name,
            email: frmEmail,
            user: frmFn + " " + frmLn,
            order_id: orderIDInstance,
            vet_id: currentVetArr.id,
            expiry: expiry
        }
          let sponsorId=resolvedSponsor.id;
          let sponsorName=resolvedSponsor.name;
          let sponsorProgram=resolvedSponsor.program;
          let sponsorCost=resolvedSponsor.cost;
          let sponsorEmailText=resolvedSponsor.emailText;
          let sponsorLogo=resolvedSponsor.logo;
        return (
            renderToString(
                <PrintTemplateCommunity
                    {...{currentVetArr,jwtKey,sponsorId,sponsorName,sponsorProgram,sponsorCost,sponsorEmailText,sponsorLogo}}
                    name={frmFn}
                    voucher={arr}
                    decoded={dec}
                    email={true}
                    outreach={outreach}
                />)
        )
    }

    async function finaliseOrder() {

        let orderId = 0;
        setBtnDisabled(true);
        try {

            let vouchers = [];
            for (let x in animals) {
                vouchers.push(animals[x]['voucher'])
            }

            const csrf = await FunctionsData.getCSRFToken();
            const requestOptionsOrder = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'token': sessionStorage.tkn,
                    'X-CSRF-Token': csrf.csrf
                },
                body: JSON.stringify({
                    email: frmEmail,
                    first: frmFn,
                    last: frmLn,
                    phone: frmPhone,
                    city: frmCity,
                    suburb: suburb,
                    street: frmStreet,
                    street_number: frmStreetNumber,
                    vet_id: currentVetArr.id,
                    campaign_id: frmCampaign,
                    vouchers: vouchers.join(','),
                    no_vouchers: vouchers.length,
                    postcode: postcode,
                    formatted_address: formattedAddress,
                    marketing_optin: frmMarketingOptin,
                    dpid: frmDPID,
                    sponsor_id: resolvedSponsor.id,
                    sponsor_name: resolvedSponsor.name,
                    sponsor_program: resolvedSponsor.program,
                    sponsor_applicant_cost: resolvedSponsor.cost,
                    sponsor_microchip_extra_cost: resolvedSponsor.microchipExtraCost,
                    sponsor_email_text: resolvedSponsor.emailText,
                    sponsor_logo: resolvedSponsor.logo,
                    order_description: orderDescription,
                    staff_email: userAccount.username,
                })
            };

            // console.log('requestOptionsOrder',requestOptionsOrder);
            let orderIDInstance = 0;
            await fetch(FunctionsData.getApiUrl("/api/orders"), requestOptionsOrder)
                .then(response => response.json())
                .then((res) => {
                    return res.id;
                })
                .then(async (r) => {
                    orderIDInstance = r;
                    setFrmOrderID(r);
                    orderId=r;

                    // ----------------------------------------------------------------
                    // GATE: do not advance to the email step until every /api/voucher
                    // write has been ACK'd as a success. Previously these fetches were
                    // fired-and-forgotten inside a for-loop, so the next .then sent
                    // the confirmation email even when the API returned 409 (voucher
                    // already issued / unavailable). That's how duplicate voucher
                    // emails (e.g. CD154462346 going to two owners) escaped the system.
                    // ----------------------------------------------------------------
                    const results = await Promise.all(animals.map(async (obj) => {
                        const requestOptionsVoucher = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'token': sessionStorage.tkn,
                                'X-CSRF-Token': csrf.csrf
                            },
                            body: JSON.stringify({
                                email: frmEmail,
                                phone: frmPhone,
                                vet_id: currentVetArr.id,
                                campaign_id: obj.campaign_id,
                                order_id: r,
                                voucher_id: obj.voucher_id,
                                sn: obj.voucher,
                                a_name: obj.name,
                                a_gender: obj.gender,
                                a_type: obj.animal_type,
                                a_id: obj.id,
                                a_microchipped: obj.is_microchipped,
                                a_is_pregnant: obj.is_pregnant,
                                a_was_pregnant: obj.was_pregnant,
                                a_age: obj.age,
                                a_color_primary: obj.a_color_primary,
                                a_color_secondary: obj.a_color_secondary,
                                a_source: obj.a_source,
                                expiry_date: obj.expiry_date,
                                sponsor_id:resolvedSponsor.id,
                                sponsor_applicant_cost: resolvedSponsor.cost,
                                a_weight: obj.a_weight,
                                a_microchip_only_flag: microchipOnly ? 1 : obj?.a_microchip_only_flag,
                            })
                        };
                        let body = null;
                        let resp;
                        try {
                            resp = await fetch(FunctionsData.getApiUrl("/api/voucher"), requestOptionsVoucher);
                            try { body = await resp.json(); } catch (e) { body = null; }
                        } catch (netErr) {
                            return { animal: obj, ok: false, status: 0, body: { error: 'Network error' } };
                        }
                        const ok = resp.ok && !(body && body.error);
                        return { animal: obj, ok, status: resp.status, body };
                    }));

                    const failed = results.filter(x => !x.ok);
                    if (failed.length > 0) {
                        const list = failed.map(f => {
                            const reason = (f.body && f.body.error) ? f.body.error : ('HTTP ' + f.status);
                            return `${f.animal && f.animal.name ? f.animal.name : '(unknown)'}: ${reason}`;
                        }).join('\n');
                        const msg =
                            "Sorry, we couldn't issue " +
                            (failed.length === 1 ? 'a voucher' : failed.length + ' vouchers') +
                            " for the following:\n\n" + list +
                            "\n\nPlease close this page and try again. If the problem keeps happening, please contact snipnchip@spca.nz.";
                        try { alert(msg); } catch (e) {}
                        setBtnDisabled(false);
                        try {
                            window.gtag('event', 'action', {
                                category: 'User',
                                action: 'Voucher issuance failed (community)',
                                order_id: orderId
                            });
                        } catch (e) {}
                        // Throw to short-circuit the chain — the email .then below
                        // must NOT fire when the underlying DB writes failed.
                        throw new Error('voucher_write_failed');
                    }

                    // All vouchers persisted — fire-and-forget Merco best-effort updates.
                    for (const x of results) {
                        const obj = x.animal;
                        const requestOptionsVoucherNew = {
                            method: 'POST',
                            headers: {'Content-Type': 'application/json', 'token': sessionStorage.tkn}
                        };
                        fetch(FunctionsData.getApiUrl("/api/merco/integration/issued/") + obj.voucher, requestOptionsVoucherNew)
                            .then(response => response.json())
                            .catch(() => { /* Merco failure is non-fatal */ });
                    }

                    return r;
                })
                .then(r => {
                    const requestOptions = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'token': sessionStorage.tkn,
                            'X-CSRF-Token': csrf.csrf
                        },
                        body: JSON.stringify({
                            html: getEmailHTML(orderIDInstance),
                            email: frmEmail,
                            first: frmFn,
                            order_id: orderId,
                            subjectNew:'Your SPCA desexing voucher'
                        })
                    };

                    fetch(FunctionsData.getApiUrl("/api/mailer/voucher"), requestOptions)
                        .then(response => response.json())
                        .then((res) => {
                            window.gtag('event', 'action', {
                                category: 'User',
                                action: 'Voucher emailed',
                                order_id: orderId,
                            });
                        });
                })
                .then(r => {
                    // toast("Order successfully created");
                    setAStep(aStep + 1);
                    window.gtag('event', 'action', {
                        category: 'User',
                        action: 'Submitted order'
                    });
                })

        } catch (err) {
            alert("issue");
        }
    }

    return (
        <div>
            <div className={"form"} style={{textAlign: 'left'}}>
                <h3 style={{marginBottom: 10, borderBottom: '2px solid #00c3b4'}}>Owner’s Details</h3>
                <div style={{marginBottom: 20}}>
                    <p>{frmFn} {frmLn}</p>
                    <p>{frmStreetNumber} {frmStreet}, {frmCity}, {postcode}</p>
                    <p>{frmEmail}</p>
                    <p>{frmPhone}</p>
                </div>
                <h3 style={{marginBottom: 10, borderBottom: '2px solid #00c3b4'}}>Vet details</h3>
                <div style={{marginBottom: 20}}>
                    <p>{v.business_name}</p>
                    <p>{v.formatted_address}</p>
                    <p>{v.email}</p>
                    {(v.phone !== '' && v.phone !== '0') ? <p>Phone: {v.phone}</p> : undefined}
                    {(v.supplier_hours !== '') ? <p>Hours: {v.supplier_hours}</p> : undefined}
                    {(v.supplier_website !== '') ? <p>{v.supplier_website}</p> : undefined}
                </div>
                <h3 style={{marginBottom: 10, borderBottom: '2px solid #00c3b4'}}>Owner’s Animals</h3>
                {animals.map((d, idx) => {
                    return (
                        <div key={Date.now() + idx} className={"animal-voucher-box"}>
                            <h3 style={{marginBottom: 0}}>{d.name}</h3>
                            {d.a_microchip_only_flag > 0 ? <p style={{marginTop: 0, color:'red'}}>Microchip only</p> : undefined}
                            <p style={{marginTop: 0}}>
                                {d.animal_type}
                                {(d.gender !== '') ? ', ' + d.gender : undefined}
                                {(d.age !== '') ? ', ' + d.age : undefined}
                                {(d.a_source !== '') ? ', ' + d.a_source : undefined}
                            </p>
                        </div>
                    )
                })}

                <Button size="full"
                        disabled={btnDisabled}
                        onClick={finaliseOrder}
                        sx={{width: '100%'}}
                        variant={"contained"}
                >
                    Issue {outreach ? 'Outreach' : 'Community'} Desexing Voucher(s)
                </Button>
            </div>

            <Button variant={""}
                    onClick={() => setAStep(aStep - 1)}
                    sx={{margin: 1}}
            >Back
            </Button>

        </div>
    )
}
